import React from "react";
import FilterIcon from "./FilterIcon";
import RefreshIcon from "./RefreshIcon";

const SearchIcon = () => {
	return (
		<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.237 13.795L8.01902 8.57703C7.60235 8.93173 7.12318 9.2063 6.58152 9.40074C6.03985 9.59518 5.49551 9.69241 4.9485 9.69241C3.61377 9.69241 2.48416 9.2304 1.55964 8.30639C0.635115 7.38237 0.172852 6.25336 0.172852 4.91936C0.172852 3.58536 0.634858 2.45549 1.55887 1.52974C2.48289 0.603988 3.61189 0.141113 4.94589 0.141113C6.27991 0.141113 7.40978 0.60337 8.33552 1.52788C9.26127 2.4524 9.72414 3.58202 9.72414 4.91676C9.72414 5.49582 9.62158 6.05618 9.41646 6.59784C9.21133 7.13951 8.9421 7.60266 8.60877 7.98728L13.8267 13.2052L13.237 13.795ZM4.9485 8.85907C6.05427 8.85907 6.98777 8.47846 7.74898 7.71724C8.5102 6.95602 8.89081 6.02252 8.89081 4.91676C8.89081 3.811 8.5102 2.8775 7.74898 2.11628C6.98777 1.35506 6.05427 0.974447 4.9485 0.974447C3.84273 0.974447 2.90924 1.35506 2.14802 2.11628C1.38681 2.8775 1.00621 3.811 1.00621 4.91676C1.00621 6.02252 1.38681 6.95602 2.14802 7.71724C2.90924 8.47846 3.84273 8.85907 4.9485 8.85907Z"
				fill="white"
			/>
		</svg>
	);
};

const DownloadIcon = () => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4.5 13.5H13.5V12.5H4.5V13.5ZM9 10.3077L12.3077 7L11.6 6.2923L9.5 8.38075V3.5H8.5V8.38075L6.4 6.2923L5.6923 7L9 10.3077ZM9.00335 18C7.7588 18 6.58872 17.7638 5.4931 17.2915C4.39748 16.8192 3.44444 16.1782 2.63397 15.3685C1.82352 14.5588 1.18192 13.6066 0.70915 12.512C0.236383 11.4174 0 10.2479 0 9.00335C0 7.7588 0.236158 6.58872 0.708475 5.4931C1.18081 4.39748 1.82183 3.44444 2.63153 2.63398C3.44123 1.82353 4.39337 1.18192 5.48795 0.709151C6.58255 0.236384 7.75212 0 8.99665 0C10.2412 0 11.4113 0.236158 12.5069 0.708475C13.6025 1.18081 14.5556 1.82182 15.366 2.63152C16.1765 3.44122 16.8181 4.39337 17.2908 5.48795C17.7636 6.58255 18 7.75212 18 8.99665C18 10.2412 17.7638 11.4113 17.2915 12.5069C16.8192 13.6025 16.1782 14.5556 15.3685 15.366C14.5588 16.1765 13.6066 16.8181 12.512 17.2909C11.4174 17.7636 10.2479 18 9.00335 18ZM9 17C11.2333 17 13.125 16.225 14.675 14.675C16.225 13.125 17 11.2333 17 9C17 6.76667 16.225 4.875 14.675 3.325C13.125 1.775 11.2333 1 9 1C6.76667 1 4.875 1.775 3.325 3.325C1.775 4.875 1 6.76667 1 9C1 11.2333 1.775 13.125 3.325 14.675C4.875 16.225 6.76667 17 9 17Z"
				fill="white"
			/>
		</svg>
	);
};

export const SvgIcons = {
	SearchIcon,
	DownloadIcon,
	FilterIcon,
	RefreshIcon,
};
